import { render, staticRenderFns } from "./ScientificDegreeFilter.vue?vue&type=template&id=3fcc4fea&"
import script from "./ScientificDegreeFilter.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports